<template>
  <div>
    <h2 class="form-section-header">{{ title }}</h2>
    <div class="inline-form-group">
      <el-col :span="8">
        <el-upload
          class="mt-10"
          action=""
          drag
          accept="image/*"
          :auto-upload="false"
          :multiple="false"
          :show-file-list="false"
          :on-change="onUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
        </el-upload>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="6">
        <div class="preview mt-10">
          <img v-if="imgSrc" :src="imgSrc" />
        </div>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="2">
        <el-button
          v-if="file || imgSrc"
          type="danger"
          icon="el-icon-delete"
          circle
          :class="{ 'preview-edit': imgSrc }"
          @click="clearUpload"
        ></el-button
      ></el-col>
    </div>
    <div class="inline-form-group" v-if="file">
      <p><b>Name</b>: {{ file.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "omniaImageUploader",

  props: {
    title: {
      type: String,
      required: true
    },
    file: {
      required: true
    },
    previewURL: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      imgSrc: null
    };
  },

  watch: {
    file(file) {
      if (file) {
        const imageBlob = new Blob([file.raw], { type: "image/jpg" });

        this.imgSrc = window.URL.createObjectURL(imageBlob);
        return;
      }

      this.imgSrc = "";
    },

    previewURL: {
      immediate: true,
      handler(val) {
        this.imgSrc = val;
      }
    }
  },

  methods: {
    onUpload(file) {
      this.$emit("onUpload", file);
    },

    clearUpload() {
      this.$emit("clearUpload");
    }
  }
};
</script>

<style lang="scss" scoped>
.preview {
  img {
    height: 150px;
    width: 150px;
    object-fit: contain;
    display: block;
    transition: all 0.3s ease-in-out;
  }
}
</style>
